<template>
  <div
    class="flex items-center justify-between gap-10 px-7 py-3 bg-white bottom-border-only"
  >
    <div class="flex gap-4 items-center self-start text-sm">

        <!-- Search Input -->
        <div
          class="transition-all duration-300 ease-in-out flex items-center bg-gray-100/70 rounded-md px-3 py-[5px] overflow-hidden"
          :class="{ 'w-[350px]': isSearchActive, 'w-[96px]': !isSearchActive }"
        >
          <img
            src="@src/assets/img/chat_bot/search-icon.svg"
            class="h-4 w-4 flex-shrink-0"
            alt="search"
          />
          <input
            v-model="searchQuery"
            type="text"
            class="bg-transparent transition-all duration-300 ease-in-out ml-1 text-sm border-0 p-1 rounded"
            :class="{ 'w-[300px]': isSearchActive, 'w-[60px]': !isSearchActive }"
            :placeholder="isSearchActive ? 'Search Anything..' : 'Search'"
            @focus="activateSearch"
            @blur="deactivateSearch"
          />
          <span v-if="isSearchActive" class="cursor-pointer" @click.stop="clearSearch">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10.623 10L13.8428 6.78027C14.1357 6.4873 14.1357 6.0127 13.8428 5.71973C13.5498 5.42676 13.0752 5.42676 12.7822 5.71973L9.5625 8.93945L6.34277 5.71973C6.0498 5.42676 5.5752 5.42676 5.28223 5.71973C4.98926 6.0127 4.98926 6.4873 5.28223 6.78027L8.50195 10L5.28223 13.2197C4.98926 13.5127 4.98926 13.9873 5.28223 14.2803C5.42871 14.4268 5.62061 14.5 5.8125 14.5C6.00439 14.5 6.19629 14.4268 6.34277 14.2803L9.5625 11.0605L12.7822 14.2803C12.9287 14.4268 13.1206 14.5 13.3125 14.5C13.5044 14.5 13.6963 14.4268 13.8428 14.2803C14.1357 13.9873 14.1357 13.5127 13.8428 13.2197L10.623 10Z" fill="#4A4A4A"/>
            </svg>
          </span>
        </div>

        <!-- Bulk Actions Dropdown -->
        <!-- <Dropdown
          v-tooltip="disableBulkAction ? 'Select at least 2 posts to perform bulk actions' : bulkActionLoader ? 'Please wait, bulk action is in progress...' : ''"
          placement="bottom-start"
          dropdown-classes="w-48"
          size="sm"
          radius="lg"
          :disabled="disableBulkAction || bulkActionLoader"
        >
        <template v-slot:selected>
          <span class="text-[#595c5f] inline-flex justify-center items-center">
            <i class="far fa-layer-group mr-2"></i>
            <span class="flex items-center gap-1">Bulk Actions

              <div v-if="bulkActionLoader">
                <clip-loader
                  color="#2294FF"
                  size="16px"
                ></clip-loader>
              </div>
            </span>

          </span>
        </template>
        <div class="space-y-1">
          <DropdownItem
            size="sm"
            class="text-sm flex items-center gap-[14px] group select-none !py-[8px]"
            @click="handleBulkDelete"
          >
            <img src="@src/assets/img/icons/delete-colored.svg" alt="Delete" class="w-4 h-4">
            <span>Delete Posts</span>
          </DropdownItem>

          <DropdownItem
            class="text-sm flex items-center gap-[14px] group select-none !py-[8px]"
            @click="bulkAction('regenerate')"
          >
            <i class="fa fa-refresh text-[#56c288]" aria-hidden="true"></i>
            <span>
              Regenerate Posts
            </span>
          </DropdownItem>

          <DropdownItem
            size="sm"
            class="text-sm flex items-center gap-[14px] group select-none !py-[8px]"
            @click="bulkAction('draft')"
          >
            <i class="fa fa-file text-[#ff922b] mr-1" aria-hidden="true"></i>
            <span>Draft Posts</span>
          </DropdownItem>
        </div>
        </Dropdown> -->

      <!-- Num of selected posts -->
      <!-- <span v-if="selectionMode" class="items-center rounded-xl font-normal px-4 py-2 text-sm flex justify-between bg-opacity-80 bg-orange-300 text-gray-900 text-opacity-70">
        {{ selectedPosts.length }} of {{ AIPosts.length }} selected
        <span class="cursor-pointer text-blue-600 ml-2" @click="selectAll">
          {{ allSelected ? 'Unselect All' : 'Select All' }}
        </span>
      </span> -->
    </div>


    <div class="flex gap-4">
      <!-- Free Tries (shown when available) -->
      <div v-if="remainingFreeTries > 0" class="relative flex items-center">
        <div
          v-tooltip="{
            content: `You have ${remainingFreeTries} free ${remainingFreeTries === 1 ? 'try' : 'tries'} left to test out our AI Content Library.`,
            placement: 'bottom',
          }"
          class="border-none px-2 py-1 rounded-xl flex items-center gap-2 bg-[#E3F2FF] text-[#2294FF] font-medium"
        >
          <i class="far fa-info-circle text-xs"></i>
          <span>{{ remainingFreeTries }} Free {{ remainingFreeTries === 1 ? 'Try' : 'Tries' }}</span>
        </div>
      </div>

      <!-- Credits (shown when no free tries available) -->
      <div
        v-else
        v-tooltip="{
          content: getCombinedCreditsTooltip,
          placement: 'bottom',
          allowHTML: true,
        }"
        class="relative flex items-center gap-2"
      >
            <img
              src="@src/assets/img/chat_bot/credit-icon.svg"
              class="transition-transform duration-200"
              alt="chat-credit"
            />
            <!-- Text Credits Display -->
            <div class="flex items-center gap-1">
              <span class="font-medium">Text: <span class="font-normal">{{  formatNumber(getCreditUsedLimit)  }} / {{ formatNumber(getCreditSubscribeLimit) }}</span></span>
            </div>

        <span>
          |
        </span>
        <!-- Image Credits Display -->
        <div class="flex items-center gap-1">
          <span class="font-medium">Image: <span class="font-normal">{{ formatNumber(getImageCreditUsedLimit) }} / {{ formatNumber(getImageCreditLimit) }}</span></span>
        </div>
      </div>

      <div class="flex flex-auto gap-4 items-center">
        <!-- Generate Post Button -->
        <Button
          v-tooltip="'Generate new posts using your post settings'"
          :loading="postGenerationLoader"
          :disabled="postGenerationLoader"
          size="sm"
          @click="handleGeneratePost"
        >
          <img
            src="@src/modules/publisher/assets/ai-icon.svg"
            class="h-4 w-4"
            alt=""
          />
          Generate Content
        </Button>
      <!-- Edit Post settings -->
        <!-- <Button
          v-tooltip="'Edit post settings'"
          class=" hover:!border-[#2294FF] group"
          variant="outline"
          color="secondary"
          size="sm"
          @click="openSettingsModal"
        >
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5 8.005C12.8807 8.005 14 6.88569 14 5.505C14 4.12429 12.8807 3.005 11.5 3.005C10.3351 3.005 9.35631 3.80174 9.07875 4.88H2.125C1.77983 4.88 1.5 5.15983 1.5 5.505C1.5 5.85019 1.77983 6.13 2.125 6.13H9.07875C9.35631 7.20825 10.3351 8.005 11.5 8.005ZM10.25 5.505C10.25 6.19536 10.8096 6.755 11.5 6.755C12.1904 6.755 12.75 6.19536 12.75 5.505C12.75 4.81465 12.1904 4.255 11.5 4.255C10.8096 4.255 10.25 4.81465 10.25 5.505ZM1.5 10.505C1.5 9.12432 2.61929 8.005 4 8.005C5.1649 8.005 6.14371 8.80175 6.42124 9.88H13.375C13.7202 9.88 14 10.1598 14 10.505C14 10.8502 13.7202 11.13 13.375 11.13H6.42124C6.14371 12.2083 5.1649 13.005 4 13.005C2.61929 13.005 1.5 11.8857 1.5 10.505ZM5.25 10.505C5.25 9.81463 4.69036 9.255 4 9.255C3.30964 9.255 2.75 9.81463 2.75 10.505C2.75 11.1954 3.30964 11.755 4 11.755C4.69036 11.755 5.25 11.1954 5.25 10.505Z"
          fill="#4A4A4A"
          class="group-hover:fill-[#2294FF] transition-colors duration-200"
        />
      </svg>
        </Button> -->

        <!-- View Switcher -->
        <div class="cst-switch">
          <div
            class="inline-flex justify-between items-center cursor-pointer py-1 rounded-xl bg-gray-200"
          >
          <a
              v-tooltip="'Grid View'"
              class="flex items-center px-1"
              @click="switchView('grid')"
            >
              <div
                :class="{
                  'bg-white text-primary-variant-1':
                    currentView === 'grid',
                }"
                class="p-2 flex justify-center items-center rounded-md space-x-2"
              >
                <img
                  v-if="currentView === 'grid'"
                  src="@assets/img/icons/planner/planner_header/planner-calendar-view-active.svg"
                  class="w-5 h-5"
                  alt="Active Grid View Icon"
                />
                <img
                  v-else
                  src="@assets/img/icons/planner/planner_header/planner-calendar-view.svg"
                  class="w-5 h-5"
                  alt="Inactive Grid View Icon"
                />
              </div>
            </a>
            <a
              v-tooltip="'List View'"
              class="flex items-center px-1"
              @click="switchView('list')"
            >
              <div
                :class="{
                  'bg-white text-primary-variant-1':
                    currentView === 'list',
                }"
                class="p-2 flex justify-center items-center rounded-md space-x-2"
              >
                <img
                  v-if="currentView === 'list'"
                  src="@assets/img/icons/planner/planner_header/planner-list-view-active.svg"
                  class="w-5 h-5"
                  alt="Active List View Icon"
                />
                <img
                  v-else
                  src="@assets/img/icons/planner/planner_header/planner-list-view.svg"
                  class="w-5 h-5"
                  alt="Inactive List View Icon"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Delete Confirmation Popup -->
  <CstConfirmationPopup
    modal-name="bulk-delete-posts"
    primary-button-text="Delete"
    @confirmed="confirmBulkDelete"
  >
    <template v-slot:head>
      <h4 class="text-xl !flex items-center gap-x-2">
        <img src="@src/assets/img/icons/delete-colored.svg" alt="Delete" class="w-5 h-5">
        Delete Post</h4>
    </template>
    <template v-slot:body>
      <p class="pt-4">Are you sure you want to delete {{ selectedPosts.length }} posts? This action cannot be undone.</p>
    </template>
    <template v-slot:footer="{ onCancel, onConfirm }">
      <Button
        variant="light"
        color="light"
        size="sm"
        @click="onCancel"
      >
        Cancel
      </Button>
      <Button
        color="danger"
        size="sm"
        @click="onConfirm"
      >
        Delete
      </Button>
    </template>
  </CstConfirmationPopup>
</template>

<script setup>
import { ref, inject, onMounted, watch, computed } from 'vue'
import { Button, Dropdown, DropdownItem } from '@contentstudio/ui'
import { useAIPostGeneration } from '@modules/publisher/ai-content-library/composables/useAIPostGeneration'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import { useFeatures } from '@modules/billing/composables/useFeatures'
import CstConfirmationPopup from '@ui/Popup/CstConfirmationPopup.vue'
import { useStore } from '@/src/store/base'
const emit = defineEmits(['view-change'])

const { canAccess } = useFeatures()
const addonAccess = canAccess('subscription_addon')

const { AIUserProfile } = useSetup()

const { postGenerationLoader, searchQuery, debouncedSearch, getPosts, selectedPosts, selectionMode, AIPosts, selectAll, allSelected, bulkAction, bulkActionLoader, currentView, remainingFreeTries } =
  useAIPostGeneration(AIUserProfile)

const root = inject('root')
const { $cstuModal, $bvModal } = root
const store = useStore()

const isSearchActive = ref(false)
const isCreditVisible = ref(false)

// disable bulk action button if less than 2 posts are selected
const disableBulkAction = computed(() => selectedPosts.value.length < 2)

// Credit related computeds and functions
const getCreditSubscribeLimit = computed(() => {
  return store.getters.getPlan?.subscription?.limits?.caption_generation_credit || 0
})

const getCreditUsedLimit = computed(() => {
  return store.getters.getPlan?.used_limits?.caption_generation_credit || 0
})

const getImageCreditLimit = computed(() => {
  return store.getters.getPlan?.subscription?.limits?.image_generation_credit || 0
})

const getImageCreditUsedLimit = computed(() => {
  return store.getters.getPlan?.used_limits?.image_generation_credit || 0
})


// Tooltip
const getCombinedCreditsTooltip = computed(() => `
  <div class="text-left p-1">
    <div class="mb-3">
      <span class="font-medium block">AI Text Credits</span>
      <span class="block my-1">${getCreditUsedLimit.value} of ${getCreditSubscribeLimit.value} used</span>
    </div>
    <div>
      <span class="font-medium block">AI Image Credits</span>
      <span class="block my-1">${getImageCreditUsedLimit.value} of ${getImageCreditLimit.value} used</span>
    </div>
    <div class="mt-2 text-sm">
      These limits are subscribed by ${getSuperAdminDetails.value?.full_name} and are available for use by all team members. They reset at the start of every month
    </div>
  </div>
`);


watch(searchQuery, debouncedSearch)

// Watch credits and show banner if low
watch(
  () => getCreditUsedLimit.value,
  (val) => {
    const textCreditsLow = val > getCreditSubscribeLimit.value - 1000 || val >= getCreditSubscribeLimit.value
  const imageCreditsLow = getImageCreditUsedLimit.value > getImageCreditLimit.value - 10 || getImageCreditUsedLimit.value >= getImageCreditLimit.value

  if (textCreditsLow || imageCreditsLow) {
    isCreditVisible.value = true
  }
  }
)

onMounted(() => {
  // Initialize search if there's a query value
  if (searchQuery.value) {
    isSearchActive.value = true
  }
})

// Animation for search activation
const activateSearch = () => {
  isSearchActive.value = true
}

const deactivateSearch = () => {
  if (!searchQuery.value) {
    isSearchActive.value = false
  }
}

const clearSearch = () => {
  searchQuery.value = ''
  isSearchActive.value = false

  // Call getPosts with false to reset the search
  getPosts(1, false)
}

const switchView = (view) => {
  currentView.value = view
  emit('view-change', view)
}

const formatNumber = (num) => {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' })
  return formatter.format(num)
}

const toggleCreditVisibility = () => {
  isCreditVisible.value = !isCreditVisible.value
}

const getSuperAdminDetails = computed(() => {
  const teamMembers = store.getters.getWorkspaces.activeWorkspace.members
  if (teamMembers)
    return teamMembers.find((member) => member.role === 'super_admin').user
  return { full_name: '' }
})

const creditsLimitsTooltip = (type, usedLimit, subscribeLimit) => {

  return `
              <div class="text-left">
      <span class="font-medium block">AI ${type} Credits</span>
      <span class="block my-2">${usedLimit} of ${subscribeLimit} used</span>
      <span class="block">
        This limit is subscribed by ${getSuperAdminDetails.value?.full_name} and being consumed by all team members.
        And the credits get reset on the start of the month.
      </span>
    </div>
                `;
};

const handleGeneratePost = () => {
  $cstuModal.show('custom-generate-modal')
}

// Handle bulk delete with confirmation
const handleBulkDelete = () => {
  $bvModal.show('bulk-delete-posts-confirmation-modal')
}

// Confirm bulk delete action
const confirmBulkDelete = () => {
  bulkAction('delete')
  $bvModal.hide('bulk-delete-posts-confirmation-modal')
}


</script>

<style lang="scss" scoped>
.credit-bar {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  height: 6px;
  width: 100%;
  cursor: default;
  user-select: none;
  &::-webkit-progress-bar {
    border-radius: 8px;
    background: rgba(240, 134, 34, 0.08);
  }
  &::-webkit-progress-value {
    background: #2294FF;
    border-radius: 8px;
    transition: width 0.3s ease;
  }
}
.credit-bar-danger::-webkit-progress-value {
  background: #EE446E;
  border-radius: 8px;
}
</style>
